
<template>
  <div class="topList">
    <div  >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form :inline="true"  ref="topListForm"  :model="topListForm" class="demo-form-inline minwidthform">
            <el-form-item>
              <ESelect
                v-model="topListForm.range_time_type"
                @change="allApiFunction(topListForm)"
                placeholder="请选择"
                size="mini"
                class="selectClass"
                style="width: 70px;"
              >
                <el-option
                  v-for="item in timeArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </ESelect>
            </el-form-item>

            <el-form-item v-if="istab=='jituan'">
              <ESelect
                v-model="topListForm.plat_id2"
                @change="allApiFunction(topListForm)"
                placeholder="请选择"
                size="mini"
                class="selectClass"
                style="width: 80px;"
              >
                <el-option value label="全部媒体"></el-option>
                <el-option
                  v-for="item in platList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </ESelect>
            </el-form-item>
            <el-form-item v-if="istab=='chanpin'">
              <ESelect
                v-model="topListForm.plat_id"
                @change="allApiFunction(topListForm)"
                placeholder="请选择"
                size="mini"
                class="selectClass"
                style="width: 80px;"
              >
                <el-option
                  v-for="item in platList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </ESelect>
            </el-form-item>
            <el-form-item>
              <ESelect
                v-model="topListForm.cost_type"
                 @change="allApiFunction(topListForm)"
                placeholder="请选择"
                size="mini"
                class="selectClass"
                style="width: 110px;"
              >
                <el-option value label="全部游戏类型"></el-option>
                <el-option
                  v-for="item in costTypeArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </ESelect>
            </el-form-item>
            <el-form-item>
              <ESelect
                v-model="topListForm.delivery_scene"
                 @change="allApiFunction(topListForm)"
                placeholder="请选择"
                size="mini"
                class="selectClass"
                style="width: 80px;"
              >
                <el-option
                  v-for="item in scenesArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </ESelect>
            </el-form-item>
            <el-form-item>
              <ESelect
                v-model="topListForm.data_type"
                 @change="allApiFunction(topListForm)"
                placeholder="请选择"
                size="mini"
                class="selectClass"
                style="width: 110px;"
              >
                <el-option value="1" label="期内总消耗"></el-option>
                <el-option value="2" label="期内日均消耗"></el-option>
              </ESelect>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <div v-if="istab=='chanpin'">
      <el-row :gutter="20">
        <el-col :span="12">
          <GOALLIST
            v-loading="loading1"
            title="消耗TOP"
            :tabledata="tableData1"
            :columns="columns1"
            @order="orderFn"
            :defaultSort="{prop: 'cost', order: 'descending'}"
            ordertit="1"
          ></GOALLIST>
        </el-col>
        <el-col :span="12">
          <GOALLIST
            v-loading="loading2"
            title="消耗波动TOP"
            :tabledata="tableData2"
            :columns="columns2"
            @order="orderFn"
            :defaultSort="{prop: 'diff_cost', order: 'ascending'}"
            ordertit="2"
          ></GOALLIST>
        </el-col>
      </el-row>
    </div>
    <div v-if="istab=='jituan'">
      <el-row :gutter="20">
        <el-col :span="12">
          <GOALLIST
            v-loading="loading3"
            title="消耗TOP"
            :tabledata="tableData3"
            :columns="columns3"
            @order="orderFn"
            :defaultSort="{prop: 'cost', order: 'descending'}"
            ordertit="3"
          ></GOALLIST>
        </el-col>
        <el-col :span="12">
          <GOALLIST
            v-loading="loading4"
            title="消耗波动TOP"
            :tabledata="tableData4"
            :columns="columns4"
            @order="orderFn"
            :defaultSort="{prop: 'diff_cost', order: 'ascending'}"
            ordertit="4"
          ></GOALLIST>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import GOALLIST from "../components/goalList";
import API from "@/api/dashboard.js";
export default {
  components: {
    GOALLIST
  },
  props: {
    platList:Array,
    istab: {
      type: String,
      defult: ""
    }
  },
  data() {
    return {
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      topListForm: {
        range_time_type: "benzhou", // 时间 - 本周
        plat_id: this.platList[0]?this.platList[0].id:'', // 厂商 产品  -OPPO 1-OPPO，3-vivo，4-华为，7-小米
        plat_id2: '', // 厂商 集团- 全部 -OPPO 1-OPPO，3-vivo，4-华为，7-小米
        cost_type: "", //游戏类型-全部
        delivery_scene: "1", //场景-全部
        data_type: "1" // 消耗-  期内总消耗
      },
      order1: "desc", //desc-降序，asc-升序 默认desc
      order2: "asc", //desc-降序，asc-升序 默认desc
      order3: "desc", //desc-降序，asc-升序 默认desc
      order4: "asc", //desc-降序，asc-升序 默认desc
      field1: "", //产品-消耗TOP-排序的prop值
      field2: "diff_cost", //产品-消耗波动TOP-排序的prop值
      field3: "", //集团-消耗TOP-排序的prop值
      field4: "diff_cost", //集团-消耗波动TOP-排序的prop值
      //时间数组
      timeArr: [
        {
          value: "jinri",
          label: "今日"
        },
        {
          value: "zuotian",
          label: "昨日"
        },
        {
          value: "benzhou",
          label: "本周"
        },
        {
          value: "shangzhou",
          label: "上周"
        },
        {
          value: "benyue",
          label: "本月"
        },
        {
          value: "shangyue",
          label: "上月"
        },
        {
          value: "benji",
          label: "本季"
        },
        {
          value: "shangji",
          label: "上季"
        },
        {
          value: "bennian",
          label: "今年"
        },
       
      ],
      // 渠道数组
      platTypeArr: [
        {
          value: "1",
          label: "OPPO"
        },
        {
          value: "3",
          label: "vivo"
        },
        {
          value: "4",
          label: "华为"
        },
        {
          value: "7",
          label: "小米"
        }
      ],
      // 游戏类型数组
      costTypeArr: [
          {
              value: "4",
              label: "IAP-应用"
          },
          {
              value: "3",
              label: "IAA-应用"
          },
          {
              value: "2",
              label: "小游戏"
          },
      ],
      //场景数组
      scenesArr: [
        {
          value: "1",
          label: "全部场景"
        },
        {
          value: "2",
          label: "商店"
        },
        {
          value: "3",
          label: "非商店"
        },
        {
          value: "4",
          label: "信息流"
        },
        {
          value: "5",
          label: "联盟"
        }
      ],
      // 产品-消耗top
      tableData1: [],
      // 产品-消耗波动top
      tableData2: [],
      // 集团-消耗top
      tableData3: [],
      // 集团-消耗波动top
      tableData4: [],
      // 产品-消耗top
      columns1: [
        {
          prop: "app_name",
          label: "产品名称",
          align: "left",
          headeralign: "center",
          minwidth: "100px",
          fixed: "left",
          tooltip: true
        },
        {
          prop: "cost",
          label: "消耗",
          align: "right",
           headeralign: "center",
          minwidth: "66px",
          sortable: "custom",
          tooltip: true,
            filter:'toThousands'
        },
        {
          prop: "roi",
          label: "累计回收ROI",
          align: "right",
           headeralign: "center",
          minwidth: "64px",
          tooltip: false
        },
        {
          prop: "register_cost",
          label: "注册成本",
          align: "right",
           headeralign: "center",
          minwidth: "60px",
          tooltip: false
        },
        {
          prop: "new_roi",
          label: "新增ROI",
          align: "right",
           headeralign: "center",
          minwidth: "60px",
          tooltip: false
        },

        {
          prop: "new_pay_rate",
          label: "新增付费率",
          align: "right",
           headeralign: "center",
          minwidth: "60px",
          tooltip: false
        }
      ],
      // 产品-消耗波动top
      columns2: [
        {
          prop: "app_name",
          label: "产品名称",
          align: "left",
          headeralign: "center",
          minwidth: "100px",
          fixed: "left",
            tooltip: true
        },
        {
          prop: "cost",
          label: "当前消耗",
          align: "right",
           headeralign: "center",
          minwidth: "66px",
          sortable: "custom",
          tooltip: true,
            filter:'toThousands'
        },
        {
          prop: "ring_cost",
          label: "环比消耗",
          align: "right",
           headeralign: "center",
          minwidth: "60px",
          sortable: "custom",
          tooltip: false,
           filter:'toThousands'
        },
        {
          prop: "diff_cost",
          label: "波动金额",
          align: "right",
           headeralign: "center",
          minwidth: "60px",
          sortable: "custom",
          tooltip: false,
           filter:'toThousands'
        },
        {
          prop: "diff_rate",
          label: "波动幅度",
          align: "right",
           headeralign: "center",
          minwidth: "60px",
          sortable: "custom",
          tooltip: false
        }
      ],
      // 集团-消耗top
      columns3: [
        {
          prop: "company_name",
          label: "集团名称",
          align: "left",
          headeralign: "center",
          minwidth: "100px",
          fixed: "left",
            tooltip: true
        },
        {
          prop: "cost",
          label: "消耗",
          align: "right",
           headeralign: "center",
          minwidth: "66px",
          sortable: "custom",
          tooltip: true,
            filter:'toThousands',
        },
        {
          prop: "date_nums",
          label: "有消耗天数",
          align: "center",
           headeralign: "center",
          minwidth: "60px",
          tooltip: false
        },
        {
          prop: "app_nums",
          label: "在投产品数",
          align: "center",
           headeralign: "center",
          minwidth: "60px",
          tooltip: false
        },
        {
          prop: "stop_app_nums",
          label: "停投产品数",
          align: "center",
           headeralign: "center",
          minwidth: "60px",
          tooltip: false
        }
      ],
      // 集团-消耗波动top
      columns4: [
        {
          prop: "company_name",
          label: "集团名称",
          align: "left",
          headeralign: "center",
          minwidth: "100px",
          fixed: "left",
            tooltip: true
        },
        {
          prop: "cost",
          label: "当前消耗",
          align: "right",
           headeralign: "center",
          minwidth: "66px",
          sortable: "custom",
          tooltip: true,
            filter:'toThousands'
        },
        {
          prop: "ring_cost",
          label: "环比消耗",
          align: "right",
           headeralign: "center",
          minwidth: "60px",
          sortable: "custom",
          tooltip: false,
            filter:'toThousands',
        },
        {
          prop: "diff_cost",
          label: "波动金额",
          align: "right",
           headeralign: "center",
          minwidth: "60px",
          sortable: "custom",
          tooltip: false,
            filter:'toThousands',
        },
        {
          prop: "diff_rate",
          label: "波动幅度",
          align: "right",
           headeralign: "center",
          minwidth: "60px",
          sortable: "custom",
          tooltip: false
        }
      ],

      value: ""
    };
  },
  created() {},
  mounted(){
  },
  methods: {
    // 获取的排序
    orderFn(val, ordertit) {
      console.log("排序返回", val);
      if (ordertit == "1") {
        //产品-消耗top
        this.field1 = val.prop;
        this.order1 = val.order == "ascending" ? "asc" : "desc";
        this.getMediaAppCostTop(this.topListForm);
      } else if (ordertit == "2") {
        //产品-消耗波动top
        this.field2 = val.prop;
        this.order2 = val.order == "ascending" ? "asc" : "desc";
        this.getMediaAppFluctuationTop(this.topListForm);
      } else if (ordertit == "3") {
        //集团-消耗top
        this.field3 = val.prop;
        this.order3 = val.order == "ascending" ? "asc" : "desc";
        this.getMediaGroupCostTop(this.topListForm);
      } else {
        this.field4 = val.prop;
        this.order4 = val.order == "ascending" ? "asc" : "desc";
        //集团-消耗波动top
        this.getMediaGroupFluctuationTop(this.topListForm);
      }
    },
    resetTopData(){
      // 点击集团或者产品，初始化select筛选项
      
      this.topListForm={
        range_time_type: "benzhou", 
        plat_id: this.platList[0]?this.platList[0].id:'', 
        plat_id2:'', 
        cost_type: "",
        delivery_scene: "1", 
        data_type: "1"
      }
      console.log('this.platList==',this.platList)
       this.allApiFunction(this.topListForm)
    },
 
    allApiFunction(form) {
      // 接口请求
       console.log('form=====是',form)
      if (this.istab == "jituan") {
        this.getMediaGroupCostTop(form);
        this.getMediaGroupFluctuationTop(form);
      } else {
        this.getMediaAppCostTop(form);
        this.getMediaAppFluctuationTop(form);
      }
    },

    // 切换时间
   
    // 切换渠道
   
    // 切换应用类型
  
    // 切换场景
    
    // 切换消耗类型
    

    //媒体KPI-集团消耗TOP1
    getMediaGroupCostTop(form) {
      this.loading3 = true;
      let option = {
        plat_id: form.plat_id2,
        delivery_scene: this.topListForm.delivery_scene,
        cost_type: this.topListForm.cost_type,
        data_type: this.topListForm.data_type,
        order: this.order3,
        range_time_type: this.topListForm.range_time_type
      };
      API.getMediaGroupCostTop(option).then(
        res => {
          let nowdata = res.data.list;
          this.tableData3 = nowdata;
          this.loading3 = false;
        },
        err => {
          this.$message.error(err.info || "集团消耗列表加载失败！");
          this.loading3 = false;
        }
      );
    },

    // 媒体KPI-集团波动TOP
    getMediaGroupFluctuationTop(form) {
      this.loading4 = true;
      let option = {
        plat_id: form.plat_id2,
        delivery_scene: this.topListForm.delivery_scene,
        cost_type: this.topListForm.cost_type,
        data_type: this.topListForm.data_type,
        order: this.order4,
        field: this.field4,
        range_time_type: this.topListForm.range_time_type
      };
      API.getMediaGroupFluctuationTop(option).then(
        res => {
          let nowdata = res.data.list;
          this.tableData4 = nowdata;
          this.loading4 = false;
        },
        err => {
          this.$message.error(err.info || "集团消耗波动列表加载失败！");
          this.loading4 = false;
        }
      );
    },
    // 媒体KPI-产品消耗TOP
    getMediaAppCostTop(form) {
      this.loading1 = true;
      let option = {
        plat_id: form.plat_id,// 处理默认不为空情况。 获取传入数组第一项。所以需要获取id
        delivery_scene: this.topListForm.delivery_scene,
        cost_type: this.topListForm.cost_type,
        data_type: this.topListForm.data_type,
        order: this.order1,
        range_time_type: this.topListForm.range_time_type
      };

      API.getMediaAppCostTop(option).then(
        res => {
          let nowdata = res.data.list;
          this.tableData1 = nowdata;
          this.loading1 = false;
        },
        err => {
          this.$message.error(err.info || "产品消耗列表加载失败！");
          this.loading1 = false;
        }
      );
    },
    // 媒体KPI-产品波动TOP
    getMediaAppFluctuationTop(form) {
      this.loading2 = true;
      let option = {
        plat_id: form.plat_id,
        delivery_scene: this.topListForm.delivery_scene,
        cost_type: this.topListForm.cost_type,
        data_type: this.topListForm.data_type,
        order: this.order2,
        field: this.field2,
        range_time_type: this.topListForm.range_time_type
      };
      API.getMediaAppFluctuationTop(option).then(
        res => {
          let nowdata = res.data.list;
          this.tableData2 = nowdata;
          this.loading2 = false;
        },
        err => {
          this.$message.error(err.info || "产品消耗波动列表加载失败！");
          this.loading2 = false;
        }
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.topList {
  width: 100%;

  .minwidthform{
    min-width: 510px;
  }

  ::v-deep.selectClass input {
    border: none;
  }

 

 ::v-deep.el-input.el-input--mini.el-input--suffix input {
     border: !important;
  }
  ::v-deep.el-form--inline .el-form-item {
    margin-right: 0px;
  }

  ::v-deep.el-select ::v-deep.el-input__inner {
    padding-right: 5px;
    padding-left: 5px;
    border: none !important;
  }

}
::v-deep.selectClass input{
    padding-right: 5px;
    padding-left: 5px;
    border: none;
}
</style>
